module.exports = __webpack_public_path__ + "img/horizontal_6_6_pp3_8023.28e07bef.png";